import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { NewButton, SaveButton } from "../../../components/Buttons";

export const SpendItems = () => {
    document.title = "Xərc maddələri";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Ayarlar", value: "/settings" },
        { name: "Xərc maddələri", value: "/settings/spenditems", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Xərc maddələri</h2>
                    <p>
                        Sahibkarın bütün xərclərini qeyd etmək üçün nəzərdə tutulub. Nümunədə yeni xərc maddəsi yaratmaq ardıcıllığı göstərilib.
                        <br />
                        Ayarlar səhifəsində <mark>xərc maddələri</mark> seçimi edildikdən sonra <NewButton>Xərc maddəsi</NewButton> düyməsini sıxıb, açılan
                        pəncərədə xərc maddəsinin adını qeyd etmək və <SaveButton /> düyməsini sıxmaq lazımdır.
                    </p>
                    <img src="/images/settings/spenditems.gif" alt="Xərc maddələri" />
                </article>
            </div>
        </div>
    );
};
